import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useLanguage } from "@/lib/i18n/LanguageContext";
import type { SigningOutputFormat } from "../../signing/outputFormat";

interface Props {
  format: SigningOutputFormat;
  onFormatChange: (format: SigningOutputFormat) => void;
  pdfAvailable: boolean;
}

export function SigningOutputOptions({ format, onFormatChange, pdfAvailable }: Props) {
  const { t } = useLanguage();
  const copy = t.signing.dialog.output;
  return (
    <div className="flex flex-col gap-2">
      <Label htmlFor="signing-output-format">{copy.label}</Label>
      <Select value={format} onValueChange={(value: SigningOutputFormat) => onFormatChange(value)}>
        <SelectTrigger id="signing-output-format" aria-describedby="signing-output-help">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="asice">{copy.asice}</SelectItem>
          <SelectItem value="pdf" disabled={!pdfAvailable}>
            {copy.pdf}
          </SelectItem>
        </SelectContent>
      </Select>
      <p id="signing-output-help" className="text-sm text-muted-foreground">
        {pdfAvailable ? (format === "pdf" ? copy.pdfHint : copy.asiceHint) : copy.singlePdfRequired}
      </p>
    </div>
  );
}
